




















import { Component, Vue } from 'vue-property-decorator';
import { mapState, mapGetters } from 'vuex';
import { Popup } from '@/shared/models/view/popup-viewmodel';
import { Config } from '../models/config-viewmodel';

@Component({
    name: 'ExportConfirmationDialog',
    computed: {
        ...mapState(['config']),
        ...mapState('root', ['popupComponent']),
        ...mapGetters('root', ['label']),
        ...mapGetters(['transcriptRequest']),
    }
})
export default class ExportConfirmationDialog extends Vue {
    public popupComponent!: Popup;
    public config!: Config;

    private labelModule = 'ModuleOverview';

    private closePopup(): void {
        this.$store.commit('setTranscriptRequest', '');
        this.$store.dispatch('root/closePopup');
    }
}
